import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import './index.css'

const SkeletonCard = () => {
    return (
        <div
            className="skeleton-custom"

        >
            <Skeleton height={60} width="60%" style={{marginBottom: "10px"}}/>
            <Skeleton height={260} width="100%"/>
        </div>
    );
};

export default SkeletonCard;
